import client from "../auth/client";
import { Auth } from "../auth/auth";

export interface ReviewContractType {
  type_id: string;
  type_code: string;
  type_name: string;
  is_active: boolean;
}

export interface ReviewContractTypesResponse {
  success: boolean;
  data: ReviewContractType[];
}

/**
 * Fetches active contract types for the standalone Contract Review feature.
 *
 * This hits the standalone review's OWN endpoint
 * (`/doc_review/contract_types/active/`) and is intentionally independent from
 * the contract drafting feature's contract-types endpoint, so the two features
 * stay decoupled.
 */
export const getActiveContractTypesForReview =
  async (): Promise<ReviewContractTypesResponse> => {
    const res = await client.get("/doc_review/contract_types/active/");
    return res?.data;
  };

export const getSignedUrlForDoc = async (reqBody: { file_name: string }) => {
  const res = await client.post("/get_signed_url/", reqBody);
  return res.data;
};

export const uploadFromLocalToDrive = async (reqBody: {
  file: File;
  vertical_id: string;
  contract_type_id?: string;
}) => {
  const res = await client.post("/doc_review/upload_from_local/", reqBody, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const convertDocToPdf = async (reqBody: { file_name: string }) => {
  const res = await client.post("/convert_doc_to_pdf_from_local/", reqBody);
  return res.data;
};

export const fileUploadFromDrive = async (reqBody: {
  file_name: string;
  file_id: string;
  vertical_id: string;
  contract_type_id?: string;
}) => {
  const res = await client.post("/doc_review/upload_drive_to_gcs/", {
    ...reqBody,
    token: Auth.getInstance().getGoogleAccessToken(),
  });
  return res.data;
};

export const getDocumentCommentFromServer = async (reqBody: {
  doc_id: string;
  mime_type?: string;
  vertical_id: string;
  contract_type_id?: string;
}) => {
  const res = await client.post(`/doc_review/review_document/`, reqBody);
  return res?.data;
};

export const getFileDataUsingDocId = async (docId: string) => {
  const res = await client.post("/doc_review/get_review_comments", {
    doc_id: docId,
  });

  return res?.data;
};

export const uploadMultipleFilesToDrive = async (reqBody: {
  file_objects: any[];
  chat_session_id?: string;
}) => {
  const res = await client.post("/ttc/multi_upload_from_drive/", {
    token: Auth.getInstance().getGoogleAccessToken(),
    ...reqBody,
  });
  return res.data;
};

export const uploadFromLocalForTTC = async (reqBody: FormData) => {
  const res = await client.post("/ttc/multi_upload_from_local/", reqBody, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};
